// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Application/types/GeneralCalculation/styles.scss
// module id = 335
// module chunks = 0